import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-import-file-dialog',
  templateUrl: './import-file-dialog.component.html',
  styleUrls: ['./import-file-dialog.component.scss']
})
export class ImportFileDialogComponent implements OnInit {

  file = {};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ImportFileDialogComponent>) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

  }

  closeDialog() {
    this.dialogRef.close();
  }

  onFileDropped(file) {
    this.file['item'] = file[0];
    this.file['progress'] = 0;
  }

  fileBrowseHandler(file) {
    this.file['item'] = file[0];
    this.file['progress'] = 0;
  }

  deleteFile() {
    if (confirm('Are you sure you want to delete this file?')) {
      this.file = {};
    }
  }

}
